import PasswordValidator from 'password-validator'

const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i

export const isValidEmail = value => {
	if (!value || value.length === 0) return true
	return EMAIL_REGEX.test(value.trim())
}

const PHONE_REGEX = /^[+#*()[\]]*([0-9][ ext+\-pw#*()[\]]*){6,45}$/

export const isValidPhoneNumber = value => {
	if (!value) return true
	return PHONE_REGEX.test(value.trim())
}

const PASSWORD_SCHEMA = new PasswordValidator()
PASSWORD_SCHEMA.min(8).has().uppercase().lowercase().digits()

export const isValidPassword = value => {
	if (!value) return true
	return PASSWORD_SCHEMA.validate(value)
}

export const makeValidation = (isValid, invalidMessage) => value => {
	if (isValid(value)) return true
	return invalidMessage
}
